import { render } from "./SaleHistory.vue?vue&type=template&id=058266f5&scoped=true&ts=true"
import script from "./SaleHistory.vue?vue&type=script&lang=ts"
export * from "./SaleHistory.vue?vue&type=script&lang=ts"

import "./SaleHistory.vue?vue&type=style&index=0&id=058266f5&lang=scss&scoped=true"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-058266f5"]])

export default __exports__